import React, { useState } from 'react'
import { Select, Tooltip as AndtTooltip } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import './styles.css'
import NetworkSwitch from '../networkSwitch'
import { Link, useLocation } from 'react-router-dom'
import { useNavigator } from '../../utitlities/navigation'
import Tooltip from 'react-simple-tooltip'
import {
  getWalletProvider,
  setWalletType,
  setWalletAmount,
  setWalletAddress
} from '../ConnectWallet/walletConnectReducer'
function Header(props) {
  const location = useLocation()
  console.log("in header : ", location?.pathname?.includes("verify/token"))
  const [navigator] = useNavigator()
  const [currentLink, setCurrentLink] = useState('')
  const { walletConnector } = useSelector(state => state.walletConnect)
  const dispatch = useDispatch()
  const [selectedNetwork, setSelectedNetwork] = useState(
    localStorage.getItem('currentNetwork') || 'MUMBAI'
  )
  let loggedUser = JSON.parse(localStorage.getItem('exsportLogin'))
  const [toggleIcon, setToggleIcon] = useState(false)
  const { Option } = Select

  const moveToPage = page => {
    try {
      navigator(page)
    } catch (error) {
    } finally {
      if (page == '/login') {
        localStorage.removeItem('exsportLogin')
        localStorage.removeItem('walletconnect')
        if (walletConnector) {
          walletConnector?.killSession()
          // walletConnector?.close();
        }
        localStorage.removeItem('WalletConnected')
        dispatch(setWalletAddress(''))
        dispatch(getWalletProvider(null))
        dispatch(setWalletType(''))
        dispatch(setWalletAmount(null))
        navigator(page)
      } else {
        navigator(page)
      }
    }
  }
  const menuOption = [
    {
      title: 'My Profile',
      icon: 'assets/images/icons/Vector (1).svg',
      link: '/myprofile'
    },
    {
      title: 'Connect Wallet',
      icon: 'assets/images/icons/Link.svg',
      link: '/connect-wallet'
    },
    {
      title: 'My Wallet',
      icon: 'assets/images/icons/mywallet.svg',
      link: '/mywallet'
    },
    {
      title: 'My Album',
      icon: 'assets/images/icons/myalbum.svg',
      link: '/album'
    },
    {
      title: 'My Rewards',
      icon: 'assets/images/icons/myalbum.svg',
      link: '/myreward'
    },
    {
      title: 'Sign Out',
      icon: 'assets/images/icons/signout.svg',
      link: '/login'
    }
  ]
  const headerMenu = [
    {
      title: 'Marketplace',
      icon: 'assets/images/icons/Vector (1).svg',
      link: 'marketplace',
      children: [
        {
          title: 'Al-Hejin NFTs',
          link: '/marketplace/alhijan',
          image: `${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/camel-ic.svg`
        },
        {
          title: 'Athlete NFTs',
          link: '/marketplace',
          image: `${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/athlete-ic.svg`
        }
      ]
    },
    {
      title: 'Rewards',
      icon: <i class='fa-light fa-album-collection'></i>,
      link: '/reward-listing'
    },
    {
      title: 'EX Sports TV',
      icon: 'assets/images/icons/reward.svg',
      link: '/exstv'
    }
    // {
    //   title: 'WTL Stream',
    //   icon: 'assets/images/icons/reward.svg',
    //   link: '/wtlstream'
    // }
  ]

  const changeNetwork = e => {
    // console.log(window?.location.pathname?.split('/')[1])
    // alert(window.location)
    window.scrollTo(0, 0)
    if (
      window.location.pathname.includes('/marketplace') ||
      window.location.pathname.includes('/details')
    ) {
      navigator('/marketplace', {})
    } else {
      navigator(`/${window?.location.pathname?.split('/')[1]}`, {})
    }
    console.log(e)
    localStorage.removeItem('RELOADING')
    localStorage.removeItem('walletconnect')
    if (walletConnector) {
      walletConnector?.killSession()
      // walletConnector?.close();
    }
    localStorage.removeItem('WalletConnected')
    dispatch(setWalletAddress(''))
    dispatch(getWalletProvider(null))
    dispatch(setWalletType(''))
    dispatch(setWalletAmount(null))
    localStorage.setItem('currentNetwork', e)
    // window.reload()
    window.location.reload()
  }

  const changeIcon = () => {
    console.log('someOne clicked me')
    // console.log(!toggleIcon)
    setToggleIcon(!toggleIcon)
  }

  if (location?.pathname?.includes("verify/token")) {
    return (
      <header class='header-section'>
        <div class='container-fluid px-3 px-lg-5'>
          <div class='row d-flex header-area align-items-center'>
            <nav class='navbar navbar-expand-lg navbar-light p-0 align-items-center'>
              <div class='navbar-brand' >
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/ex-sports-logo.png`}
                  class='logo'
                  alt='logo'
                />
              </div>
            </nav>
          </div>
        </div>
      </header>
    )
  }

  return (
    <header class='header-section'>
      <NetworkSwitch />
      <div class='overlay'>
        <div class='container-fluid px-3 px-lg-5'>
          <div class='row d-flex header-area align-items-center'>
            <nav class='navbar navbar-expand-lg navbar-light p-0 align-items-center'>
              <button
                id='getUser'
                style={{ display: 'none' }}
                onClick={() => {
                  navigator('/marketplace')
                }}
              ></button>
              <button
                id='networkSwitch'
                style={{ display: 'none' }}
                data-bs-toggle='modal'
                data-bs-target='#wrong-chain'
                onClick={() => {
                  try {
                    var x = document.getElementsByTagName('BODY')?.[0]
                    x.style.overflowY = 'scroll'
                    x.style.paddingRight = 'unset'
                    var elements =
                      document.getElementsByClassName('modal-backdrop')
                    for (var i = 0; i <= elements?.length; i++) {
                      elements[i].style.display = 'none'
                    }
                  } catch (e) {
                  } finally {
                  }
                }}
              >
                click me
              </button>
              <Link class='navbar-brand' to='/'>
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/ex-sports-logo.png`}
                  class='logo'
                  alt='logo'
                />
              </Link>
              <button
                id='sessionExpire'
                style={{ display: 'none' }}
                onClick={() => {
                  navigator('/session', {})
                }}
              ></button>
              <div class='nav-serch-bar ms-3 desktop-search desktop-input'>
                <i class='bi bi-search' style={{ marginLeft: '5px' }}></i>
                <input
                  type='text'
                  class='form-control search-input searchbox'
                  value={props?.searchQuery}
                  placeholder=''
                  autocomplete='new-password'
                  onChange={e => {
                    props?.searchFiled(e?.target?.value)
                  }}
                ></input>
                {props?.search == true ? (
                  <div
                    className='searchCancel'
                    id='searchnft'
                    onClick={() => {
                      props?.searchFiled('')
                    }}
                  >
                    <img
                      src='../../assets/images/icons/cross-icon.svg'
                      className='CROSS-BTN'
                    />
                  </div>
                ) : null}
              </div>
              {loggedUser != null ? (
                <div
                  class='dropdown dropdown profile-dropdown position-relative mx-2 d-lg-none '
                  id='sharedd'
                >
                  <button
                    class='share-btn pdd-btn d-flex align-items-center dropdwon-toggle header-menu'
                    data-bs-toggle='dropdown'
                    id='sharedd'
                    style={{
                      height: '25px !important',
                      width: '25px !important'
                    }}
                  >
                    {loggedUser?.data?.image != null &&
                      loggedUser?.data?.image != 'no-photo.jpeg' &&
                      loggedUser?.data?.image != 'null' ? (
                      <img
                        className='profile-img'
                        src={loggedUser?.data?.image}
                      ></img>
                    ) : (
                      <div className='profile-img'>
                        <div class='img-body'></div>
                      </div>
                    )}
                  </button>
                  <ul class='dropdown-menu' aria-labelledby='sharedd'>
                    {menuOption?.map(item => {
                      return (
                        <li>
                          <Link
                            to={item?.link}
                            class='dropdown-item'
                            onClick={e => {
                              // e.preventDefault()
                              setCurrentLink(item?.link)
                              moveToPage(item?.link)
                            }}
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${item?.icon}`}
                              style={{ width: '18px', marginRight: '5px' }}
                            />{' '}
                            {item?.title}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ) : null}
              <button
                class='navbar-toggler'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#ex-navbar'
                aria-controls='navbarSupportedContent'
                aria-expanded='false'
                aria-label='Toggle navigation'
                onClick={changeIcon}
              >
                {toggleIcon ? (
                  <i className='fas fa-times'></i>
                ) : (
                  <i className='fas fa-bars'></i>
                )}
              </button>
              <div class='collapse navbar-collapse' id='ex-navbar'>
                <div class='nav-serch-bar ms-3 desktop-search  mobile-view'>
                  <i class='bi bi-search' style={{ marginLeft: '5px' }}></i>
                  <input
                    type='text'
                    class='form-control search-input searchbox'
                    value={props?.searchQuery}
                    placeholder=''
                    autocomplete='new-password'
                    onChange={e => {
                      if (/^\s*$/.test(e?.target?.value) != true) {
                        props?.searchFiled(e?.target?.value)
                      }
                    }}
                  ></input>
                  {props?.search == true ? (
                    <div
                      className='searchCancel'
                      id='searchnft'
                      onClick={() => {
                        props?.searchFiled('')
                      }}
                    >
                      <img
                        src='../../assets/images/icons/cross-icon.svg'
                        className='CROSS-BTN'
                      />
                    </div>
                  ) : null}
                </div>
                <ul class='navbar-nav ms-lg-5 mb-2 mb-lg-0 align-items-center'>
                  {headerMenu?.map(item => {
                    console.log('==item====0', item)
                    return (
                      <>
                        <li
                          style={{ cursor: 'pointer' }}
                          class={`nav-item nav-dropdown ${item?.link == window?.location?.pathname ||
                            window?.location?.pathname.includes(item?.link)
                            ? 'active'
                            : ''
                            }`}
                          onClick={() => {
                            if (item?.children?.length > 0) {
                              return
                            }
                            const label = document.getElementById('ex-navbar')
                            label?.classList?.remove('show')
                            setCurrentLink(item?.link)
                            navigator(item?.link, {})
                            setToggleIcon(false)
                          }}
                        >
                          {/* nav-dropdown-link */}
                          <Link
                            to={item?.children?.length > 0 ? '#' : item?.link}
                            onClick={e => {
                              e?.preventDefault()

                              if (item?.children?.length == 0) {
                                navigator(item?.link, {})
                              }
                            }}
                            class={`nav-link ${item?.children ? 'nav-dropdown-link' : ''
                              }`}
                          >
                            {item?.title}{' '}
                          </Link>

                          <ul class='nav-column'>
                            {item?.children != undefined
                              ? item?.children?.map(item1 => {
                                if (process.env.REACT_APP_ENVIRONMENT == "live" && item1?.title == "Al-Hejin NFTs") {
                                  return null
                                }
                                return (
                                  <li
                                    className='nav-item'
                                    onClick={e => {
                                      e?.stopPropagation()
                                      e?.preventDefault()
                                      navigator(item1?.link, {})
                                      window?.location?.reload()
                                    }}
                                  >
                                    <Link to={item1?.link}>
                                      <img
                                        src={item1?.image}
                                        alt='athlete-icon'
                                      />{' '}
                                      {item1?.title}{' '}
                                    </Link>
                                  </li>
                                )
                              })
                              : null}
                          </ul>
                        </li>
                      </>
                    )
                  })}
                  {loggedUser == null ? (
                    <div
                      class='btn-sec-navbar d-lg-none mt-4'
                      style={{ width: '100%' }}
                    >
                      <div
                        class=' w-100 mx-0'
                        style={{
                          columnGap: '10px',
                          paddingRight: '10px',
                          paddingLeft: '10px'
                        }}
                      >
                        <div style={{ display: 'flex' }}>
                          <Tooltip
                            background='red'
                            color='white'
                            placement='right'
                            content='Our NFTs can be found on several Blockchains that we’re integrated with. You can select your prefered Blockchain network here.'
                          >
                            <button
                              class='f-group info-btn me-2 infoIcon'
                              aria-label='buy product'
                              style={{
                                border: '1px solid #737373',
                                width: '40px',
                                height: '40px',
                                background: 'transparent',
                                borderRadius: '5px '
                              }}
                            >
                              <i
                                class='bi bi-info-circle-fill'
                                style={{ color: 'white' }}
                              ></i>
                            </button>
                          </Tooltip>
                          <div style={{ width: '100%' }}>
                            <div class='f-group' style={{ width: '100%' }}>
                              <Select
                                placeholder='Payment Option'
                                style={{
                                  width: '95%',
                                  marginLeft: '9px',
                                  marginBottom: '10px'
                                }}
                                className='paymentOptions'
                                defaultValue={selectedNetwork}
                                optionFilterProp='children'
                                onChange={e => {
                                  changeNetwork(e)
                                  // console.log("network change")
                                  // console.log(e)
                                  // alert("I am Network 1")
                                }}
                              >
                                <Option value='EHETERUM'>
                                  {' '}
                                  <img
                                    style={{ marginLeft: '4px' }}
                                    src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/eh.svg`}
                                  ></img>{' '}
                                  <span style={{ marginLeft: '5px' }}>
                                    Ethereum
                                  </span>
                                </Option>
                                <Option value='MUMBAI'>
                                  {' '}
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/polygon.png`}
                                  ></img>
                                  Polygon
                                </Option>
                                <Option value='BINANCE'>
                                  {' '}
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/bnb.svg`}
                                  ></img>{' '}
                                  Binance
                                </Option>
                              </Select>
                            </div>
                          </div>
                        </div>
                        {loggedUser == null ? (
                          <div class='col-12 mt-3'>
                            <Link
                              to='/login'
                              class='btn btnm-primary login-btn'
                              onClick={() => {
                                const label =
                                  document.getElementById('ex-navbar')
                                label?.classList?.remove('show')

                                navigator('/login')
                                setToggleIcon(false)
                              }}
                            >
                              Log in
                            </Link>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    <div
                      class='btn-sec-navbar d-lg-none mt-4'
                      style={{ width: '100%' }}
                    >
                      <div
                        class=' w-100 mx-0'
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          columnGap: '10px',
                          paddingRight: '10px',
                          paddingLeft: '10px'
                        }}
                      >
                        <Tooltip
                          background='red'
                          color='white'
                          placement='right'
                          trigger='focus'
                          content='Our NFTs can be found on several Blockchains that we’re integrated with. You can select your prefered Blockchain network here.'
                        >
                          <button
                            class='f-group info-btn me-2 infoIcon'
                            aria-label='buy product'
                            style={{
                              border: '1px solid #737373',
                              width: '40px',
                              height: '40px',
                              background: 'transparent',
                              borderRadius: '5px '
                            }}
                          >
                            <i
                              class='bi bi-info-circle-fill'
                              style={{ color: 'white' }}
                            ></i>
                          </button>
                        </Tooltip>
                        <div style={{ width: '100%' }}>
                          <div class='f-group' style={{ width: '100%' }}>
                            <Select
                              placeholder='Payment Option'
                              style={{
                                width: '95%',
                                marginLeft: '9px',
                                marginBottom: '10px'
                              }}
                              className='paymentOptions'
                              defaultValue={selectedNetwork}
                              optionFilterProp='children'
                              onChange={e => {
                                changeNetwork(e)
                                // console.log("network change")
                                // console.log(e)
                                // alert("I am Network 1")
                              }}
                            >
                              <Option value='EHETERUM'>
                                {' '}
                                <img
                                  style={{ marginLeft: '4px' }}
                                  src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/eh.svg`}
                                ></img>{' '}
                                <span style={{ marginLeft: '5px' }}>
                                  Ethereum
                                </span>
                              </Option>
                              <Option value='MUMBAI'>
                                {' '}
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/polygon.png`}
                                ></img>
                                <span>Polygon</span>
                              </Option>
                              <Option value='BINANCE'>
                                {' '}
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/bnb.svg`}
                                ></img>{' '}
                                Binance
                              </Option>
                            </Select>
                          </div>
                        </div>
                        {loggedUser == null ? (
                          <div class='col-12 mt-3'>
                            <Link
                              to='/login'
                              class='btn btnm-primary login-btn'
                              onClick={() => {
                                const label =
                                  document.getElementById('ex-navbar')
                                label?.classList?.remove('show')

                                navigator('/login')
                                setToggleIcon(false)
                              }}
                            >
                              Log in
                            </Link>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  )}
                </ul>
              </div>
              <div
                class='btn-sec-navbar btn-sec-desktop'
                style={{ columGap: '10px' }}
              >
                {/* <!--info icon for desktop--> */}
                <AndtTooltip
                  color='red'
                  trigger='hover'
                  title='Our NFTs can be found on several Blockchains that we’re integrated with. You can select your prefered Blockchain network here.'
                >
                  <button
                    class='f-group info-btn me-2 infoIcon'
                    aria-label='buy product'
                    style={{
                      border: '1px solid #737373',
                      width: '40px',
                      height: '40px',
                      background: 'transparent',
                      borderRadius: '5px',
                      marginRight: '10px',
                      fontSize: '18px'
                    }}
                  >
                    <i
                      class='bi bi-info-circle-fill'
                      style={{ color: 'white' }}
                    ></i>
                  </button>
                </AndtTooltip>
                {/* <!--End info icon for desktop--> */}
                <div class='f-group'>
                  <Select
                    placeholder='Payment Option'
                    style={{ width: '100%', marginRight: '20px' }}
                    className='paymentOptions mainNetwork'
                    optionFilterProp='children'
                    defaultValue={selectedNetwork}
                    onChange={e => {
                      changeNetwork(e)
                      console.log(e)
                    }}
                  >
                    <Option value='EHETERUM'>
                      {' '}
                      <img
                        style={{ marginLeft: '4px' }}
                        src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/eh.svg`}
                      ></img>{' '}
                      <span style={{ marginLeft: '5px' }}> Ethereum</span>
                    </Option>
                    <Option value='MUMBAI'>
                      {' '}
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/polygon.png`}
                      ></img>{' '}
                      <span>Polygon</span>
                    </Option>
                    <Option value='BINANCE'>
                      {' '}
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/bnb.svg`}
                      ></img>{' '}
                      Binance
                    </Option>
                  </Select>
                </div>
                {loggedUser == null ? (
                  <Link to='/login' class='btn btnm-primary login-btn'>
                    Log in
                  </Link>
                ) : (
                  <>
                    <div
                      class='dropdown myProfile '
                      style={{ marginLeft: '10px' }}
                      id='sharedd'
                    >
                      <button
                        class='share-btn dropdown-toggle- profile-dropdown header-menu'
                        data-bs-toggle='dropdown'
                        id='sharedd'
                        style={{ height: '40px' }}
                      >
                        {loggedUser?.data?.image != null &&
                          loggedUser?.data?.image != 'no-photo.jpeg' &&
                          loggedUser?.data?.image != 'null' ? (
                          <img
                            className='profile-img'
                            src={loggedUser?.data?.image}
                          ></img>
                        ) : (
                          <div className='profile-img '>
                            <div class='img-body'></div>
                          </div>
                        )}
                        <span className='profile-name'>My Profile</span>
                      </button>
                      <ul class='dropdown-menu' aria-labelledby='sharedd'>
                        {menuOption?.map(item => {
                          return (
                            <li>
                              <Link
                                to={item?.link}
                                class='dropdown-item'
                                onClick={e => {
                                  // e.preventDefault()
                                  setCurrentLink(item?.link)
                                  moveToPage(item?.link)
                                }}
                              >
                                {/* <img src={`${process.env.REACT_APP_IMAGE_URL}/${item?.icon}`} /> {item?.title} */}
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}/${item?.icon}`}
                                  style={{ width: '18px', marginRight: '5px' }}
                                />{' '}
                                {item?.title}
                              </Link>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
